(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["club-membership-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('club-membership-purchase')) {
    customElements.define('club-membership-purchase', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('change', () => this.updatePrice(), { signal: this.controller.signal });
        this.updatePrice();
      }
      disconnectedCallback() { this.controller?.abort(); }
      updatePrice() {
        const selected = this.querySelector('input[name="selling_plan"]:checked');
        const price = this.closest('.product-information')?.querySelector('product-price .price');
        if (selected && price) price.textContent = selected.dataset.price;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
